import React, {Component} from "react";
import {Input} from "reactstrap";
import {connect} from "react-redux";
import departmentSettingsSelectors from "../../store/department-settings/selectors";
class DashboardFtoSelect extends Component {


  get selected() {
    if(this.props.multiple) {
      return this.props.value || []
    }

    return this.props.value
  }

  get defaultLabel() {
    if(this.props.multiple) {
      return this.selected.length? `Add ${ this.props.ftoShortLabel} for compare`: 'Select ' + this.props.ftoShortLabel
    }

    return 'Select ' + this.props.oitShortLabel;
  }

  get value() {
    if(this.props.multiple) {
      return this.props.expanded || !this.props.value? '': this.props.value[0]
    }

    return this.props.value
  }

  setSelectedFto(ftoGuid) {
    if(this.props.multiple) {
      if(!this.props.expanded) {
        this.props.onInput([ftoGuid])
      } else if(!this.selected.find(guid => guid === ftoGuid)) {
        this.props.onInput([...this.selected, ftoGuid])
      }
    } else {
      this.props.onInput(ftoGuid)
    }
  }

  getFto(ftoGuid) {
    return this.props.ftos.find(fto => fto.guid === ftoGuid)
  }

  removeFto(ftoGuid) {
    this.props.onInput(this.props.value.filter(guid => guid !== ftoGuid))
  }

  get selectedFtos() {
    return this.props.value ? this.props.value.map((ftoGuid) => this.getFto(ftoGuid)): []
  }

  render() {
    return (
      <div className="dashboard-oit-select">
        <Input
          name="type"
          onChange={event =>
            this.setSelectedFto(event.target.value)
          }
          type="select"
          className="select"
          value={this.props.value}
        >
          <option defaultValue={''}>{this.defaultLabel}</option>
          {this.props.ftos && this.props.ftos.map(fto => (
            <option key={fto.guid} value={fto.guid}>{fto.getFullName()}</option>
          ))}
        </Input>

        {this.props.children}

        {this.props.expanded && this.props.multiple && this.selectedFtos.map(fto => (
            <div className="oit-badge" key={fto.guid} onClick={() => this.removeFto(fto.guid)}>
              <i className="fa fa-times"></i>
              {fto.getFullName()}
            </div>
        ))}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    ftos: state.ftos.list,
    departmentSettings: state.departmentSettings.settings,
    ftoShortLabel: departmentSettingsSelectors.ftoShortLabel(state),
    userContext: state.common.userContext
  };
}
export default connect(mapStateToProps)(DashboardFtoSelect)
